const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnMicS(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.67 -5.41)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(2.67 5.41)",
    style: {
      fill: "rgba(0,0,0,.75)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.67 10.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 249",
    width: 6,
    height: 9,
    rx: 3,
    transform: "translate(1 -1)",
    style: {
      fill: "none",
      stroke: "current",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 89",
    transform: "translate(4 11)",
    style: {
      fill: "none",
      stroke: "current",
      strokeWidth: 2
    },
    d: "M0 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 90",
    transform: "translate(1 15)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "current",
      strokeWidth: 2
    },
    d: "M0 0h6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 550",
    d: "M-516.815 240.648a5 5 0 0 1-5 5 5 5 0 0 1-5-5",
    transform: "translate(525.815 -234.648)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "current",
      strokeWidth: 2
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMicS);
export default __webpack_public_path__ + "static/media/btn-mic-s.bf8acf0824be8d78caa13e2b7af9be73.svg";
export { ForwardRef as ReactComponent };